<template lang="pug">
    .second-form.relative
        v-overlay(
            v-model="loading"
        )
            enl-loading
        v-overlay(
            v-model="formSavedInfo"
        )
            h1.white--text Formularz zapisano!

        v-container
            div(
                v-if="!initialLoading&&!notFound&&!errorInfo"
            )
                v-row.first-form-data

                    //- DANE URZĄDZENIA
                    v-col(cols="12")
                        h1 Dane urządzenia

                    v-col(cols="12").py-0
                        v-text-field(
                            label="Model urządzenia"
                            v-model="formData.deviceData.deviceName"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="8").py-0
                        v-text-field(
                            label="Numer seryjny (SN)"
                            v-model="formData.deviceData.serialNumber"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="4").py-0
                        v-text-field(
                            label="Data instalacji"
                            v-model="formattedDate"
                            color="#339900"
                            dense
                            readonly
                        )

                    //- DANE INSTALATORA

                    v-col(cols="12")
                        h1 Dane instalatora

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Nazwa firmy"
                            v-model="formData.installatorData.companyName"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Osoba kontaktowa"
                            v-model="formData.installatorData.contactPerson"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Numer kontaktowy"
                            v-model="formData.installatorData.contactNumber"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Adres e-mail"
                            v-model="formData.installatorData.email"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="12")
                        h3 Adres instalatora

                    v-col(cols="8").py-0
                        v-text-field(
                            label="Ulica"
                            v-model="formData.installatorData.address.street"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="4").py-0
                        v-text-field(
                            label="Numer budynku"
                            v-model="formData.installatorData.address.buildingNumber"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="4").py-0
                        v-text-field(
                            label="Kod pocztowy"
                            v-model="formData.installatorData.address.zipCode"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="8").py-0
                        v-text-field(
                            label="Miasto"
                            v-model="formData.installatorData.address.city"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Region"
                            v-model="formData.installatorData.address.region"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Państwo"
                            v-model="formData.installatorData.address.country"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="12")
                        h3 Adres do zwrotu urządzenia

                    v-col(cols="8").py-0
                        v-text-field(
                            label="Ulica"
                            v-model="formData.installatorData.returnAddress.street"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="4").py-0
                        v-text-field(
                            label="Numer budynku"
                            v-model="formData.installatorData.returnAddress.buildingNumber"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="4").py-0
                        v-text-field(
                            label="Kod pocztowy"
                            v-model="formData.installatorData.returnAddress.zipCode"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="8").py-0
                        v-text-field(
                            label="Miasto"
                            v-model="formData.installatorData.returnAddress.city"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Region"
                            v-model="formData.installatorData.returnAddress.region"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Państwo"
                            v-model="formData.installatorData.returnAddress.country"
                            color="#339900"
                            dense
                            readonly
                        )


                    //- DANE UŻYTKOWNIKA

                    v-col(cols="12")
                        h1 Dane klienta końcowego

                    v-col(cols="12").py-0
                        v-text-field(
                            label="Imię i nazwisko"
                            v-model="formData.customerData.customerName"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Numer kontaktowy"
                            v-model="formData.customerData.contactNumber"
                            color="#339900"
                            dense
                            readonly
                        )

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Adres e-mail"
                            v-model="formData.customerData.email"
                            color="#339900"
                            dense
                            readonly
                        )


                    //- SPECYFIKACJA

                    v-col(cols="12")
                        h1 Specyfikacja aktualnych podłączeń

                    v-col(cols="6").py-0
                        v-text-field(
                            label="Voc. (V):"
                            v-model="formData.specificationData.specification"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="6").py-0
                        v-text-field(
                            label="Vmp. (V):"
                            v-model="formData.specificationData.vmp"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="6").py-0
                        v-text-field(
                            label="Moc max. (W):"
                            v-model="formData.specificationData.power"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="6").py-0
                        v-text-field(
                            label="Ilość obsługiwanych punktów MPPT (A/B)"
                            v-model="formData.specificationData.pointsNumber"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="6").py-0
                        v-text-field(
                            label="Ilość paneli podłączonych do punktu MPPT (A/B)"
                            v-model="formData.specificationData.panelsNumber"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="6").py-0
                        v-text-field(
                            label="Aktualne napięcie w sieci AC (V) (L1/L2/L3)"
                            v-model="formData.specificationData.voltage"
                            color="#339900"
                            dense
                            readonly
                        )

                    //- OPIS USZKODZENIA

                    v-col(cols="12")
                        h1 Opis uszkodzenia

                    v-col(cols="8").py-0
                        v-text-field(
                            label="Informacja na wyświetlaczu"
                            v-model="formData.issueData.screen"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(cols="4").py-0
                        v-text-field(
                            label="Kolor diody LED"
                            v-model="formData.issueData.ledColor"
                            color="#339900"
                            height="auto"
                            dense
                            readonly
                        )
                    v-col(cols="12").py-0
                        v-textarea(
                            label="Opis usterki"
                            v-model="formData.issueData.desc"
                            color="#339900"
                            dense
                            readonly
                        )
                    v-col(:cols="phone?12:12").py-0
                        v-text-field(
                            label="Osoba wypełniająca formularz"
                            v-model="formData.issueData.author"
                            color="#339900"
                            dense
                            readonly
                        )

                    //- ZAŁĄCZNIKI

                    v-col(cols="12")
                        h1 Załączniki

                        div.pb-5
                            h3 Schemat instalacji
                            a(
                                v-if="!!formData.files.diagram[0]"
                                :href="formData.files.diagram[0].url"
                                :download="formData.files.diagram[0].url"
                                target="_blank"
                                style="text-decoration: none"
                            )
                                v-btn(
                                    depressed
                                ) {{formData.files.diagram[0].originalName}}

                        div.pb-5

                            h3 Karta katalogowa paneli

                            //- Uwaga: 'Szkic instalacji' został zmieniony na 'Kartę katalogową paneli'
                            //- Zmienione tylko labele, nazwy obiektów po staremu dla zachowania kompatybilności z backendem.
                            //- ~PB

                            a(
                                v-if="!!formData.files.sketch[0]"
                                :href="formData.files.sketch[0].url"
                                download
                                target="_blank"
                                style="text-decoration: none"
                            )
                                v-btn(
                                    depressed
                                ) {{formData.files.sketch[0].originalName}}

                        div.pb-5
                            h3 Dowód zakupu
                            a(
                                v-if="!!formData.files.invoice[0]"
                                :href="formData.files.invoice[0].url"
                                download
                                target="_blank"
                                style="text-decoration: none"
                            )
                                v-btn(
                                    depressed
                                ) {{formData.files.invoice[0].originalName}}

                        div
                            h3 Uprawnienia elektryczne
                            a(
                                v-if="!!formData.files.electriciansLicence[0]"
                                :href="formData.files.electriciansLicence[0].url"
                                download
                                target="_blank"
                                style="text-decoration: none"
                            )
                                v-btn(
                                    depressed
                                ) {{formData.files.electriciansLicence[0].originalName}}


                //- WYPEŁNIA PRACOWNIK
                v-form(ref="form")
                    v-row
                        v-col(cols="12")
                            v-divider.mb-5
                            h1 Finalizacja wymiany

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Model wymienionego urządzenia"
                                v-model="additionalInfo.deviceName"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="12").py-0
                            v-text-field(
                                label="Wymienione przez"
                                v-model="additionalInfo.replacedBy"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="6").py-0
                            v-text-field(
                                label="Numer seryjny (SN)"
                                v-model="additionalInfo.serialNumber"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                                validate-on-blur
                            )

                        v-col(cols="6").py-0
                            enl-date-picker(
                                label="Data wymiany"
                                v-model="additionalInfo.replaceDate"
                                :rules="textRules"
                                color="#339900"
                                filled
                                dense
                            )

                //- BUTTONS
                v-row
                    v-col(cols="12")
                        .d-flex.justify-space-between
                            v-btn(
                                color="success"
                                depressed
                                width="50%"
                                @click="saveForm"
                            )
                                span.font-weight-bold(
                                    v-if="!formData.isSaved"
                                ) Zapisz
                                span.font-weight-bold(
                                    v-if="formData.isSaved"
                                ) Zaktualizuj

                            v-btn(
                                outlined
                                width="48%"
                                @click="download"
                                :disabled="!formData.isSaved"
                            )
                                span Pobierz

            div(
                v-if="notFound"
                style="height: calc(100vh - 24px)"
            ).d-flex.align-center.justify-center
                h3 Nie znaleziono takiego zgłoszenia.
            div(
                v-if="initialLoading"
                style="height: calc(100vh - 24px)"
            ).d-flex.align-center.justify-center
                enl-loading
            div(
                v-if="errorInfo"
                style="height: calc(100vh - 24px)"
            ).d-flex.align-center.justify-center
                h3 Wystąpił błąd. Spróbuj ponownie.

</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";

import EnlDatePicker from "@/components/EnlDatePicker";
import EnlLoading from "@/components/EnlLoading";

export default {
    name: "second-form",

    components: {
        EnlDatePicker,
        EnlLoading
    },

    data: () => ({
        loading: false,
        formSavedInfo: false,
        notFound: false,
        initialLoading: false,
        errorInfo: false,
        claimId: null,
        additionalInfo: {
            deviceName: null,
            serialNumber: null,
            replacedBy: null,
            replaceDate: null
        },
        // rules
        textRules: [
            val => {
                if (val) return true;
                else return "Pole jest wymagane";
                // return true;
            }
        ]
    }),

    computed: {
        ...mapState("secondForm", ["secondForm"]),
        formData() {
            return this.secondForm;
        },
        formattedDate() {
            if (this.formData.deviceData.installationDate) {
                return moment(this.formData.deviceData.installationDate).format(
                    "YYYY-MM-DD"
                );
            }
        }
    },

    methods: {
        ...mapActions("secondForm", ["POPULATE_FORM", "SAVE_FORM"]),
        async saveForm() {
            let valid = this.$refs.form.validate();
            if (valid) {
                try {
                    this.loading = true;
                    let query = await this.SAVE_FORM({
                        dataToSend: this.additionalInfo,
                        claimId: this.claimId
                    });
                    this.loading = false;
                    this.formSavedInfo = true;
                    setTimeout(() => (this.formSavedInfo = false), 1000);
                } catch (error) {
                    // console.log(error);
                    this.loading = false;
                    this.errorInfo = true;
                    return error;
                }
            }
        },
        download() {
            const link = document.createElement("a");
            link.href = this.formData.pdf;
            link.setAttribute("download", "claim #" + this.claimId);
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
        }
    },

    async created() {
        try {
            this.initialLoading = true;
            this.claimId = this.$route.params.id;
            let query = await this.POPULATE_FORM(this.claimId);
            // console.log("query:", query);
            if (this.secondForm.isSaved) {
                this.additionalInfo = JSON.parse(
                    JSON.stringify(this.secondForm.additionalInfo)
                );
            }
            this.initialLoading = false;
            return query;
        } catch (error) {
            this.initialLoading = false;
            this.notFound = true;
            // console.log(error);
            return error;
        }
    },

    mounted() {
        document.title = "Obsługa zgłoszenia";
    }
};
</script>
<style lang="sass" scoped>
@import "@/styles/global.sass"
.second-form
    h1
        margin: 15px 0 15px
    h3
        margin: 10px 0 10px
    .first-form-data
        .col
            margin-bottom: 10px
</style>